import { useFormikContext } from 'formik';

import Button from 'components/shared/Button/Button';

const Footer = ({ closePopover }) => {
  const { handleSubmit, isSubmitting } = useFormikContext();

  return (
    <div className="flex items-center justify-end gap-2 border-0 !border-b-0 !border-t border-solid !border-neutral-100 bg-white px-4 py-3 shadow-[0px_-2px_16px_rgba(0,0,0,0.06)]">
      <Button text="Cancel" color="neutral" style="outlined" onClick={closePopover} size="small" />
      <Button
        text="Export"
        onClick={handleSubmit}
        isLoading={isSubmitting}
        isDisabled={isSubmitting}
        size="small"
      />
    </div>
  );
};

export default Footer;
